import { render } from "./LotDocumentsModal.vue?vue&type=template&id=7b96c484&scoped=true&ts=true&lang=pug"
import script from "./LotDocumentsModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./LotDocumentsModal.vue?vue&type=script&lang=ts&setup=true"

import "./LotDocumentsModal.vue?vue&type=style&index=0&id=7b96c484&lang=scss&scoped=true"
import "./LotDocumentsModal.vue?vue&type=style&index=1&id=7b96c484&lang=scss"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b96c484"]])

export default __exports__